var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import { loginRequestSuccess, registerRequestSuccess, registerRequestFail, verifyCodeRequestFail } from "./actions";
import { combineReducers } from "redux";
var defaultState = {
    id: -1,
    email: "",
    phone: "",
};
var errorsDefaultState = {
    errors: "",
    code: -1,
    name: "",
    data: ""
};
var loginReducer = createReducer({}, defaultState)
    .on(loginRequestSuccess, function (state, payload) {
    return {
        id: payload.id,
        email: payload.email,
        phone: payload.phone
    };
})
    .on(registerRequestSuccess, function (state, payload) {
    return {
        id: payload.id,
        email: payload.email,
        phone: payload.phone,
    };
});
var errorsReducer = createReducer({}, errorsDefaultState)
    .on(registerRequestFail, function (state, payload) {
    return {
        code: payload.code,
        name: payload.name,
        data: payload.data,
        errors: payload.errors
    };
})
    .on(verifyCodeRequestFail, function (state) {
    return __assign(__assign({}, state), { didCodeVerificationFailed: true });
});
var authReducer = combineReducers({
    login: loginReducer,
    errors: errorsReducer,
});
var AuthReducer = {
    auth: authReducer
};
export default AuthReducer;



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/ducks/index.ts
// module id = 689
// module chunks = 0